import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { CORPORATE_LEAD, APARTMENT_LEAD, ALLIANCE, SUPPLY } from './type';

export const createCorporateLead = (val) => async (dispatch) => {
  const {
    sourceLead,
    leadCatId,
    name,
    building_name,
    currentLocation,
    email,
    secondContact,
    islocationType,
    pocVal,
    pocName,
    fmcName,
    pocDesVal,
    number,
    supplyName,
    isLat,
    isLong,
    area,
    zone,
    city,
    geoStateId,
    geoCityId,
    pinId,
    slotsNo,
    gatesNo,
    vms,
    reservedSlots,
    fcfsSlots,
    address1,
    address2,
    poc,
    contact_date,
    leadSourceOther,
    gates,
    evChargersNo,
    mailCamp,
    occupancy,
    existing_setup,
    marquee_site,
    partners,
    products
  } = val;
  const data = {
    lead_source_id: sourceLead,
    lead_category_id: leadCatId,
    client_name: `${name}`,
    building_name:`${building_name}`,
    current_location: `${currentLocation}`,
    location_type: islocationType,
    tp_poc_site_id: pocVal,
    poc_other_details: `${poc}`,
    other_poc_sites: `${poc}`,
    poc_name: `${pocName}`,
    fmc_name: `${fmcName}`,
    poc_designation: `${pocDesVal}`,
    poc_phone_number: `${number}`,
    poc_email: `${email}`,
    poc_secondary_contact: `${secondContact}`,
    supply_id: supplyName,
    latitude: `${isLat}`,
    longitude: `${isLong}`,
    area_id: area,
    zone_id: zone,
    city_id: city,
    geo_state: geoStateId,
    geo_city: geoCityId,
    geo_pincode: pinId,
    no_of_slots: slotsNo,
    no_of_gates: gatesNo,
    reserved_slots: reservedSlots,
    fcfs_slots: fcfsSlots,
    address_line_one: `${address1}`,
    address_line_two: `${address2}`,
    contact_date: `${contact_date}`,
    other_lead_source: `${leadSourceOther}`,
    vms_type: vms,
    gate_details: gates,
    no_of_evchargers: evChargersNo,
    mail_campaign: mailCamp.value,
    occupancy: occupancy,
    existing_setup: existing_setup,
    marquee_site: marquee_site,
    partners: partners,
    products: products
  };
  // console.log(data); return false;
  const res = await callWebService(
    callTypes.post,
    data,
    Config.createLead.corporate
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: CORPORATE_LEAD, payload: data.response.data });
    return true;
  }
};

export const createApartmentLead = (val) => async (dispatch) => {
  const {
    sourceLead,
    alternateChannle,
    mainSource,
    otherSource,
    leadCatId,
    name,
    currentLocation,
    email,
    secondContact,
    islocationType,
    pocVal,
    pocName,
    pocDesVal,
    number,
    isLat,
    isLong,
    area,
    zone,
    city,
    geoStateId,
    geoCityId,
    pinId,
    slotsNo,
    gatesNo,
    reservedSlots,
    fcfsSlots,
    address1,
    address2,
    avgChFlat,
    // date,
    flatNo,
    // rwaTenure,
    carsNo,
    HelpStaffNo,
    poc,
    leadSourceOther,
    contact_date,
    interactionTypeLead,
    societyType,
    // gateType,
    vms,
    existingGates,
    occupancy,
    disputeLevel,
    societyUpkeeping,
    amenities,
    managedBy,
    maintainanceCharges,
    securityAgency,
    gates

  } = val;

  const data = {
    lead_source_id: sourceLead,
    alternateChannle: alternateChannle,
    mainSource: mainSource,
    otherSource: otherSource,
    lead_interaction_type_id: interactionTypeLead,
    lead_category_id: leadCatId,
    client_name: `${name}`,
    current_location: `${currentLocation}`,
    location_type: islocationType,
    tp_poc_site_id: pocVal,
    poc_other_details: `${poc}`,
    other_poc_sites: `${poc}`,
    poc_name: `${pocName}`,
    poc_designation: `${pocDesVal}`,
    poc_phone_number: `${number}`,
    poc_email: `${email}`,
    poc_secondary_contact: `${secondContact}`,
    latitude: `${isLat}`,
    longitude: `${isLong}`,
    area_id: area,
    zone_id: zone,
    city_id: city,
    geo_state: geoStateId,
    geo_city: geoCityId,
    geo_pincode: pinId,
    no_of_slots: slotsNo,
    no_of_gates: gatesNo,
    reserved_slots: reservedSlots,
    fcfs_slots: fcfsSlots,
    no_of_flats: flatNo,
    no_of_staff: HelpStaffNo,
    no_of_cars: carsNo,
    // rwa_end_date: `${date}`,
    // rwa_tenure: `${rwaTenure}`,
    rwa_maintenance_charge: `${avgChFlat}`,
    address_line_one: `${address1}`,
    address_line_two: `${address2}`,
    contact_date: `${contact_date}`,
    other_lead_source: `${leadSourceOther}`,
    society_type: societyType,
    // gate_type: gateType,
    vms_type: vms,
    existing_gates: existingGates,
    occupancy: occupancy,
    dispute_level: disputeLevel,
    society_upkeeping: societyUpkeeping,
    amenities: amenities,
    managed_by: managedBy,
    maintainance_charges: maintainanceCharges,
    security_agency: securityAgency,
    gate_details: gates
  };
  // console.log(data); return false;
  const res = await callWebService(
    callTypes.post,
    data,
    Config.createLead.apartment
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: APARTMENT_LEAD, payload: data.response.data });
    return true;
  }
};

export const createAllianceLead = (val) => async (dispatch) => {
  const {
    sourceLead,
    name,
    currentLocation,
    email,
    secondContact,
    islocationType,
    pocName,
    pocDesVal,
    number,
    isLat,
    isLong,
    area,
    zone,
    city,
    geoStateId,
    geoCityId,
    pinId,
    address1,
    address2,
    remarks,
    tpPoc,
    leadSourceOther,
    contact_date,
  } = val;
  const data = {
    lead_source_id: sourceLead,
    lead_category_id: 13,
    client_name: `${name}`,
    current_location: `${currentLocation}`,
    location_type: islocationType,
    tp_poc_site_id: tpPoc,
    poc_name: `${pocName}`,
    poc_designation: `${pocDesVal}`,
    poc_phone_number: `${number}`,
    poc_email: `${email}`,
    poc_secondary_contact: `${secondContact}`,
    latitude: `${isLat}`,
    longitude: `${isLong}`,
    area_id: area,
    zone_id: zone,
    city_id: city,
    geo_state: geoStateId,
    geo_city: geoCityId,
    geo_pincode: pinId,
    address_line_one: `${address1}`,
    address_line_two: `${address2}`,
    remarks: remarks,
    other_lead_source: `${leadSourceOther}`,
    contact_date: `${contact_date}`,
  };

  const res = await callWebService(
    callTypes.post,
    data,
    Config.createLead.b2bAlliance
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: ALLIANCE, payload: data.response.data });
    return true;
  }
};

export const createSupplyLead = (val) => async (dispatch) => {
  const {
    name,
    sourceLead,
    typeSite,
    typeSubSite,
    pocName,
    pocDesVal,
    number,
    email,
    currentLocation,
    islocationType,
    isLat,
    isLong,
    area,
    zone,
    city,
    geoStateId,
    geoCityId,
    pinId,
    address1,
    address2,
    carSlots,
    bikeSlots,
    otherSlots,
    occupancyCar,
    occupancyBike,
    entryGates,
    exitGates,
    parkingFloors,
    parkingRevenue,
    securityAgency,
    parkingAgency,
    photos
    // contact_date,
  } = val;
  const data = {
    client_name: `${name}`,
    lead_source_id: `${sourceLead}`,
    site_type_id: `${typeSite}`,
    site_sub_type_id: `${typeSubSite}`,
    poc_name: `${pocName}`,
    poc_designation: `${pocDesVal}`,
    poc_phone_number: `${number}`,
    poc_email: `${email}`,
    current_location: `${currentLocation}`,
    location_type: islocationType,
    latitude: `${isLat}`,
    longitude: `${isLong}`,
    area_id: area,
    zone_id: zone,
    city_id: city,
    geo_state: `${geoStateId}`,
    geo_city: `${geoCityId}`,
    geo_pincode: `${pinId}`,
    address_line_one: `${address1}`,
    address_line_two: `${address2}`,
    car_slots: `${carSlots}`,
    bike_slots: `${bikeSlots}`,
    other_slots: `${otherSlots}`,
    occup_car: occupancyCar?.id,
    occup_bike: occupancyBike?.id,
    entry_gates: `${entryGates}`,
    exit_gates: `${exitGates}`,
    parking_floors: `${parkingFloors}`,
    parking_rev: `${parkingRevenue}`,
    sec_agency: `${securityAgency}`,
    park_agency: `${parkingAgency}`,
    site_photos: `${photos}`
    // requirement_description: `${requirDesc}`,
    // other_site_type: `${siteSubTypeOther}`,
    // contact_date: `${contact_date}`
  };
  const res = await callWebService(
    callTypes.post,
    data,
    Config.createLead.supply
  );
  if (res?.data?.status === 0 || res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: SUPPLY, payload: data.response?.data ?? data.data });
    return true;
  }
};
